﻿import { required } from 'vuelidate/lib/validators';
import checkoutService from '../../api/checkout';
import { sprintf } from '../../utils/extensions';

export default {
    name: 'broadband-provider-change',
    template: '#broadband-provider-change-template',
    mounted() {
        this.selectedButton = 'Yes';
        this.selectedDslProviderName = this.viewmodel.previousSelectedDslProvider || '';
        this.selectedFiberProviderName = this.viewmodel.previousSelectedFiberProvider || '';
        this.selectedCoaxProviderName = this.viewmodel.previousSelectedCoaxProvider || '';
        this.customerNumber = this.viewmodel.previousSelectedDslCustomerNumber || '';
        this.setInvalidState();
        this.dslProviders = this.viewmodel.broadbandProviders;
        this.coaxType = this.viewmodel.coaxType;
        this.fiberType = this.viewmodel.fiberType;
        this.dslType = this.viewmodel.dslType;
        this.showDslProviderList = this.viewmodel.dslType;
        this.saveChoice();
        this.userSelectAutoTermination = true;
    },
    data: () => ({
        dslProviders: {},
        selectedCoaxProviderName: '',
        selectedDslProviderName: '',
        selectedFiberProviderName: '',
        customerNumber: '',
        output: '',
        isCustomerNumberValid: false,
        showDslProviderList: false,
        showCoaxProviderList: false,
        showFiberProviderList: false,
        selectedButton: 'Yes',
        showPopUp: false,
        popUpMessage: '',
        youSeePopUpMessage: '',
        currentPopUpMessage: '',
        selectedProvider: null,
        IsCheckBoxVisible: false,
        AcceptedPermission: false,
        account: '',
        showCancelled: false,
        filterString: '',
        matchingAccounts: [],
        loading: true,
        providerName: '',
        eventText: '',
        Status: '',
        items: [{ txt: 'Ja', val: 1 }],
        checked: '',
        parentIdAlert: false,
        coaxType: false,
        fiberType: false,
        dslType: false,
        userSelectAutoTermination: true
    }),
    computed: {
        providerTooltip: function () {
            return '[{"paragraph":"' + this.selectedProvider.description + '"}]';
        }
    },
    watch: {
        selectedDslProviderName: function () {
            if (this.selectedDslProviderName) {
                this.setChosenProvider();
            } else {
                this.selectedProvider = null;
            }
            this.$data.providerName = name;
            if (this.selectedDslProviderName == "Telia") {
                this.getBroadbandDetails(name);
                this.setInvalidState();
                return this.$data.providerName;
            }
            else {
                this.customerNumber = "";
                this.parentIdAlert = false;
            }

            this.setInvalidState();
        },
        userSelectAutoTermination: function () {
            this.setInvalidState();
        },
        selectedCoaxProviderName: function () {

            this.IsCheckBoxVisible = false;
            this.AcceptedPermission = false;
            var self = this;
            this.viewmodel.coaxProviders.forEach(function (provider) {

                if (provider.name == self.selectedCoaxProviderName) {
                    self.IsCheckBoxVisible = provider.askPermissionToTerminateSubscription;
                }
            })
            this.currentPopUpMessage = this.selectedCoaxProviderName == 'YouSee' ? this.youSeePopUpMessage : this.popUpMessage;
            this.showPopUp = !this.IsCheckBoxVisible;
            this.setInvalidState();
        },
        selectedFiberProviderName: function () {

            this.IsCheckBoxVisible = false;
            this.AcceptedPermission = false;
            var self = this;
            this.viewmodel.fiberProviders.forEach(function (provider) {

                if (provider.name == self.selectedFiberProviderName) {
                    self.IsCheckBoxVisible = provider.askPermissionToTerminateSubscription;
                }
            })

            this.currentPopUpMessage = this.selectedFiberProviderName == 'YouSee' ? this.youSeePopUpMessage : this.popUpMessage;
            this.showPopUp = !self.IsCheckBoxVisible;
            this.setInvalidState();
        },
        customerNumber: function () {
            if (!this.selectedProvider) {
                this.isCustomerNumberValid = true;
                return;
            }

            const regex = new RegExp(this.selectedProvider.regEx);
            this.isCustomerNumberValid = regex.test(this.customerNumber);
        },
        selectedButton: function () {
            this.saveChoice();
        }
    },
    props: ['blockid', 'viewmodel'],
    validations: {
        selectedButton: {
            required
        }
    },
    methods: {
        getErrorMessage: function(messageFormat) {
            return sprintf(messageFormat, this.customerNumber);
        },
        acceptPermission: function(e) {
            this.setInvalidState();
        },

        setChosenProvider: function() {
            for (let i = 0; i < this.dslProviders.length; i++) {
                const provider = this.dslProviders[i];
                if (provider.name !== this.selectedDslProviderName) {
                    continue;
                }
                this.selectedProvider = {
                    description: provider.description,
                    regEx: provider.regularExpression,
                    labelText: provider.identifierName
                };
            }
        },
        saveChoice() {
            const parameters = { buttonClicked: this.selectedButton, blockId: this.blockid };
            checkoutService.saveInfo(this.viewmodel.apiUrl,
                parameters,
                (data) => {
                    this.showDslProviderList = data.ShowDSLProviderList;
                    this.showCoaxProviderList = data.ShowCoaxProviderList;
                    this.showFiberProviderList = data.ShowFiberProviderList;
                    if (!this.showCoaxProviderList &&  !this.showFiberProviderList) {
                        this.showPopUp = data.ShowPopUp;
                    }
                    this.currentPopUpMessage = data.PopUpMessage;
                    this.popUpMessage = data.PopUpMessage;
                    this.youSeePopUpMessage = data.YouSeePopUpMessage;
                    this.setInvalidState();
                }
            );
        },
        setInvalidState() {
            var invalid = this.$v.selectedButton.invalid;

            if (this.showDslProviderList) {
                var invalid = this.selectedDslProviderName == "";
            } else if (this.showCoaxProviderList) {
                if (this.IsCheckBoxVisible) {
                    var invalid = !this.AcceptedPermission;
                }
                else {
                    var invalid = this.selectedCoaxProviderName == "";
                }
            } else if (this.showFiberProviderList) {
                if (this.IsCheckBoxVisible) {
                    var invalid = !this.AcceptedPermission;
                }
                else {
                    var invalid = this.selectedFiberProviderName == "";
                }
            }

            if (this.userSelectAutoTermination == 'false') {
                invalid = false;
            }

            this.$store.dispatch('updateValidState', { invalid: invalid, blockId: this.blockid });
        },
        getBroadbandDetails: function (name) {
            var self = this;
            const parameters = { buttonClicked: 'Yes', blockId: this.blockid };
            checkoutService.saveInfo(this.viewmodel.bruceApiUrl,
                parameters,
                (data) => {
                    self.matchingAccounts = data;
                    self.customerNumber = data[0].AccountId;
                    if (data[0].ParentAccountId.length > 0)
                         self.parentIdAlert = true;
                }
            );
        }
    }
}
